<template>
 <div style="margin-top:7%">
  <div class="news-detail maxW">
    <div class="top-menu">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/home/newsList' }">{{
          $t("homepage.news")
        }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $t("homepage.newsDetail") }}</el-breadcrumb-item>
        <!-- <el-breadcrumb-item>{{newsData.name}}</el-breadcrumb-item> -->
      </el-breadcrumb>
    </div>
    <div class="news-detail-content clear">
      <div class="detail-content-l fl">
        <h3>{{ newsData.name }}</h3>
        <div class="news-info">
          <div class="creater-info">
            <span>{{ newsData.user_name }}</span>
            <span>{{ newsData._create_time }}</span>
            <span>{{ newsData.clicks }}{{ $t("global.check") }}</span>
          </div>
        </div>
        <div class="news-content" v-html="newsData.content"></div>
        <button @click="dianzan" class="dianzan">
          <img
            v-if="newsData.is_thumbsup == 1"
            class="fl"
            src="../../../assets/images/zan2@2x.png"
            :alt="$t('homepage.like1')"
          />
          <img
            v-if="newsData.is_thumbsup == 0"
            class="fl"
            src="../../../assets/images/zan1@2x.png"
            :alt="$t('homepage.like0')"
          />
          <span class="fr">{{ newsData.news_thumbsup_num }}</span>
        </button>
      </div>
      <div class="news-other fr">
        <div class="detail-content-r" style="margin-bottom: 20px">
          <template>
            <el-table :data="annexData" style="width: 100%">
              <el-table-column
                prop="name"
                :label="$t('homepage.annex')"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <img
                    src="../../../assets/images/icon_enclosue.png"
                    alt=""
                    class="link-annex"
                  />
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="scope.row.name"
                    placement="top"
                    :disabled="isTooltip"
                  >
                    <span class="name-annex">
                      <span @mouseover="onMouseOver">{{
                        scope.row.name.split(".")[1]
                          ? scope.row.name
                          : scope.row.name +
                            "." +
                            scope.row.attachemnt_path.split(".")[1]
                      }}</span>
                    </span>
                  </el-tooltip>
                  <img
                    src="../../../assets/images/icon_download.png"
                    alt=""
                    class="xiazai-annex"
                    @click="downloadFile(scope.row)"
                  />
                </template>
              </el-table-column>
            </el-table>
          </template>
        </div>
        <div class="detail-content-r">
          <template>
            <el-table
              :data="otherNewsData"
              style="width: 100%"
              @cell-click="handleChoose"
            >
              <el-table-column
                prop=""
                :label="$t('homepage.latest')"
                :show-overflow-tooltip="true"
                width="260"
              >
                <template slot-scope="scope">
                  {{ scope.row.name }}
                </template>
              </el-table-column>
              <el-table-column
                prop="friend_time"
                label=""
                :show-overflow-tooltip="true"
                width="80"
              >
              </el-table-column>
            </el-table>
          </template>
        </div>
      </div>
    </div>
  </div>
 </div>
</template>
<script>
export default {
  data() {
    return {
      newsId: this.$route.query.id, //左侧当前展示出来的新闻公告id
      newsData: {}, //左侧当前展示的新闻数据
      otherNewsData: [], //右侧其他新闻公告数据
      annexData: [], //右侧附件数据
      isTooltip: true,
    };
  },
  created() {
    this.getNewsInfo();
    this.getOtherNews();
  },
  mounted() {
    this.addNewClick();
  },
  methods: {
    onMouseOver(e) {
      //决定文字提示是否显示
      if (e.target.offsetWidth > e.target.parentNode.clientWidth) {
        this.isTooltip = false;
      } else {
        this.isTooltip = true;
      }
    },
    dianzan() {
      let success = (res) => {
        this.getNewsInfo();
      };
      this.$ajax({
        url: "api/news/change_news_thumbsup",
        method: "put",
        data: {
          id: this.newsId,
        },
        func: {
          success: success,
        },
      });
    },

    //获取左侧显示的新闻信息详情
    getNewsInfo() {
      let success = (res) => {
        this.newsData = res.data;
        // console.log(res,'新闻信息 ')
        this.annexData = res.data.attachment_info;
      };
      this.$ajax({
        url: "api/news/news_detail",
        method: "get",
        params: {
          id: this.newsId,
        },
        func: {
          success: success,
        },
      });
    },
    //获取右侧其他新闻公告
    getOtherNews() {
      let success = (res) => {
        this.otherNewsData = res.data.data;
      };
      this.$ajax({
        url: "api/news/news_list",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          DecisionPlatform: "logintable",
        },
        method: "get",
        params: {
          page_index: 1,
          page_size: 4,
          order: "top",
        },
        func: {
          success: success,
        },
      });
    },
    //其他新闻公告： 点击单个新闻进行展示切换
    handleChoose(row) {
      this.$router.push({
        path: "/home/newsDetail",
        query: {
          id: row.id,
        },
      });
    },
    // 添加观看记录
    addNewClick() {
      let success = (res) => {};
      this.$ajax({
        url: "api/news/add_new_click",
        method: "put",
        data: {
          id: this.newsId,
        },
        func: {
          success: success,
        },
      });
    },
    // 下载：
    downloadFile(obj) {
      // console.log(obj)
      window.location.href =
        this.BASE_URL +
        "/index/openclass/download_video_file_huiyi?id=" +
        obj.id +
        "&table_name=news_attachment";
    },
  },
};
</script>
<style lang="scss">
.breakrow {
  word-wrap: break-word;
  word-break: break-all;
}

.news-detail {
  overflow: hidden;
  padding-bottom: 40px;

  .top-menu {
    margin: 32px 0 10px;

    .el-breadcrumb {
      font-size: 14px;
      color: #666;
      height: 20px;
      line-height: 20px;
    }

    .el-breadcrumb__separator.el-icon-arrow-right {
      color: #000;
    }
  }

  .share-box {
    .a-tit {
      height: 28px;
      line-height: 28px;
      font-size: 12px;
      color: #656e6c;
      margin-right: 10px;
    }
  }

  .detail-content-l {
    padding: 40px;
    display: inline-block;
    width: 800px;
    background-color: #fff;
    box-sizing: border-box;

    h3 {
      font-size: 24px;
      line-height: 31px;
      font-weight: bold;
      text-align: center;
      margin-bottom: 50px;
      @extend .breakrow;
    }

    .news-info {
      margin-bottom: 60px;
    }

    .creater-info {
      display: inline-block;
      line-height: 28px;

      span {
        font-size: 12px;
        color: #888;
        margin-right: 10px;
      }
    }

    .news-content {
      font-size: 14px;
      line-height: normal;
      @extend .breakrow;
    }

    .dianzan {
      display: block;
      margin: 60px auto 0;
      background: #fff;
      // box-shadow: none;
      border: 1px solid #dddddd;
      border-radius: 4px;
      padding: 12px 30px 12px 14px;
      width: 129px;
      line-height: 22px;
      text-align: left;
      overflow: hidden;

      img {
        width: 24px;
        height: 22px;
        transform: translateY(-2px);
      }

      span {
        margin-left: 28px;
        color: #666666;
        font-size: 18px;
      }
    }
  }

  .news-other {
    width: 380px;
  }

  .detail-content-r {
    width: 100%;
    display: inline-block;
    background-color: #fff;
    padding: 20px;
    box-sizing: border-box;

    span {
      display: inline-block;
    }
    .name-annex {
      margin-left: 5px;
      width: 65%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .link-annex {
      padding-top: 3px;
    }
    .xiazai-annex {
      cursor: pointer;
      float: right;
    }

    .el-table__header .has-gutter th {
      padding: 0 0 10px;

      .cell {
        padding: 0;
        height: 16px;
        line-height: 16px;
        color: #333333;
        font-size: 12px;
      }
    }

    .el-table__body-wrapper.is-scrolling-left {
      table {
        width: auto;

        tr {
          td {
            padding: 13px 0;
            height: 20px;
            line-height: 20px;

            > div {
              padding-left: 0 !important;
            }
          }
        }
      }
    }

    .el-table__row {
      td:nth-child(1) {
        font-size: 14px;
        cursor: pointer;
        color: #000;
      }

      td:nth-child(2) {
        font-size: 12px;
        color: #888888;
        float: right;
        text-align: right;

        > div {
          padding-right: 0;
        }
      }

      &:last-child {
        td {
          border: 0 none;
        }
      }
    }
  }

  .el-table .cell {
    padding-left: 0 !important;
  }
}
</style>
